<template>
  <div class="firmware">

    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <card-title icon-image="mdi-file-download-outline" title="Firmware" text-color="title" />
            <MDKTable
                ref="MDKTable"
                :fields="fields"
                :items="items"
                :pagination="paginationOptions"
                v-on:filter-change="getItems" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CardTitle from '@/views/components/cardTitle.vue';

export default {
  components: { CardTitle },
  data() {
    const _api = this.$_app.service.firmware;
    return {
      jqlApi: _api,
      fields: _api.columnInfos,
      items: [],
      paginationOptions: {
        currentPage: 1,
        totalCount : 0,
        perPage: 10,
      }
    }
  },
  mounted() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    getItems(filterOptions, sortOptions) {
      const vm = this;
      sortOptions = '-id';
      vm.jqlApi.searchByJql(filterOptions, sortOptions, vm.paginationOptions.perPage, vm.$refs.MDKTable.currentPage)
          .then(res => {
            vm.items = res.content;
            vm.paginationOptions.totalCount = res.totalElements;
          }).catch(err => {
            console.log(err);
          });
    }
  }
}
</script>
